import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import Text from "components/Text";

function ConfirmationModal({
  isModalOpen,
  closeModal,
  handleConfirm,
  title,
  modalContent,
  modalSubContent,
  btnText,
  t,
}) {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-dialog-centered delete-modal modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={require("assets/images/cross.svg").default} alt="close" />
      </span>
      <ModalBody>
        <Text
          size="25px"
          marginBottom="11px"
          weight="500"
          color="#111b45"
          align="center"
        >
          <span className="modal-title-25">{title}</span>
        </Text>
        <Text
          size="16px"
          //   marginBottom="40px"
          weight="300"
          color=" #535b5f"
          align="center"
        >
          {modalContent}
        </Text>
        <Text
          size="16px"
          marginBottom="40px"
          weight="300"
          color=" #535b5f"
          align="center"
        >
          {modalSubContent}
        </Text>
        <div className="btn-box d-md-flex gap-sm">
          <button
            className="button button-round button-shadow mb-3 w-sm-100 w-md-50 mr-md-2"
            title={t("delete")}
            onClick={handleConfirm}
          >
            {btnText}
          </button>
          <button
            className="mb-md-3 button button-round button-border btn-mobile-link button-dark w-50"
            title={t("cancel")}
            onClick={closeModal}
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(ConfirmationModal);
